/**
 * SNCKD. — Cart Box Preview
 * Ersetzt den Signature-Box-Thumbnail im Warenkorb-Drawer
 * durch eine CSS-gestapelte Vorschau der gewählten Sorten.
 */
(function () {
  'use strict';

  var BASE_IMG = 'https://cdn.shopify.com/s/files/1/1022/4982/4601/files/Signature-Box-leer-2.jpg';
  var CDN = 'https://cdn.shopify.com/s/files/1/1022/4982/4601/files/';

  var IMAGE_MAP = {
    '4-x-acai-chia-bowl':               CDN + 'Acai-Chia-Bowl-4er.png',
    '4-x-pistazien-tiramisu':           CDN + 'Pistazien-Tiramisu-4er.png',
    '4-x-gambas-garden-bowl':           CDN + 'Gambas-Garden-4er.png',
    '4-x-red-beet-bowl':                CDN + 'Red-Beet-4er.png',
    '4-x-file-street-slice':            CDN + 'Filet-Street-Slice-4er.png',
    '4-x-berry-nut-cheese-pop':         CDN + 'Berry-Nut-4er.png',
    '4-x-pasta-delight':                CDN + 'Pasta-Delight-4er.png',
    '4-x-chia-nuss-blaubeere-porridge': CDN + 'Chia-Porridge-4er.png',
    '4-x-natural-candy':                CDN + 'Natural-Candy-4er.png',
    '4-x-slaw-salmon':                  CDN + 'Slaw-Salmon-4er.png',
    '4-x-teriyaki-chicken-bowl':        CDN + 'Teryaki-Chicken-4er.png',
    '4-x-tokyo-cucumber':               CDN + 'Tokyo-Cucumber-4er.png',
    '4-x-little-italy':                 CDN + 'Little-Italy-4er.png',
    '4-x-plant-based-protein':          CDN + 'Plant-Base-Protein-4er.png',
    '4-x-antipasti-reloaded':           CDN + 'Antipasti-4er.png',
    '4-x-moms-cocos-love':              CDN + 'Moms-Cocols-Love-4er.png',
    '4-x-love-bowl':                    CDN + 'Love-Bowl-4er.png',
    '4-x-potato-smash':                 CDN + 'Potato-Smash-4er.png',
    '4-x-gyoza-curry-bowl':             CDN + 'Gyoza-Curry-4er.png'
  };

  // Slot-Positionen identisch zur Produktseite
  var SLOT_TOPS = ['13.6%', '28.4%', '42.5%', '57.3%', '71.8%'];

  function buildMiniPreview(imgUrls) {
    var layers = imgUrls.map(function (url, i) {
      if (!url) return '';
      return (
        '<img src="' + url + '" alt="" ' +
        'style="position:absolute;left:19%;top:' + SLOT_TOPS[i] + ';' +
        'width:61%;height:14.85%;object-fit:cover;pointer-events:none;" ' +
        'loading="eager">'
      );
    }).join('');

    return (
      '<div style="position:relative;width:100%;aspect-ratio:1/1;overflow:hidden;background:#000;">' +
        '<img src="' + BASE_IMG + '" alt="Signature Box" ' +
        'style="width:100%;height:100%;object-fit:cover;display:block;">' +
        layers +
      '</div>'
    );
  }

  function applyPreview(cartData) {
    if (!cartData || !cartData.items) return;

    cartData.items.forEach(function (item) {
      var props = item.properties || {};

      // Nur Signature-Box-Zeilen (erkennen an Sorte 1 Property)
      if (!props['Sorte 1']) return;

      var imgUrls = [1, 2, 3, 4, 5].map(function (n) {
        var handle = props['_handle_' + n] || '';
        return IMAGE_MAP[handle] || '';
      });

      if (imgUrls.every(function (u) { return !u; })) return;

      // DOM-Element für dieses Line Item finden (Horizon: data-parent-key auf <tr>)
      var lineKey = String(item.key);
      var itemEl = document.querySelector('[data-parent-key="' + lineKey + '"]') ||
                   document.querySelector('[data-line-item-key="' + lineKey + '"]') ||
                   document.querySelector('[data-key="' + lineKey + '"]');

      if (!itemEl) return;

      var thumbEl = itemEl.querySelector('img');
      if (!thumbEl) return;

      var wrap = thumbEl.closest('a') || thumbEl.parentElement;
      if (!wrap) return;

      // Vorschau nur einmal einsetzen
      if (wrap.querySelector('.snckd-cart-preview')) return;

      thumbEl.style.display = 'none';
      var preview = document.createElement('div');
      preview.className = 'snckd-cart-preview';
      preview.style.cssText = 'width:100%;';
      preview.innerHTML = buildMiniPreview(imgUrls);
      wrap.insertBefore(preview, thumbEl);
    });
  }

  function refreshPreview() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(applyPreview)
      .catch(function () {});
  }

  // Beim Öffnen des Drawers und bei DOM-Änderungen im Drawer
  var observer = new MutationObserver(function (mutations) {
    var relevant = mutations.some(function (m) {
      return Array.from(m.addedNodes).some(function (n) {
        return n.nodeType === 1 &&
          (n.matches && (n.matches('cart-drawer-component') || n.matches('[data-cart-drawer]')) ||
           n.querySelector && (n.querySelector('cart-drawer-component') || n.querySelector('[data-cart-drawer]')));
      });
    });
    if (relevant) refreshPreview();
  });

  // Auch auf DialogOpenEvent hören (Horizon-eigenes Event)
  document.addEventListener('dialog:open', function (e) {
    var target = e.target || e.detail && e.detail.dialog;
    if (target && (target.closest('cart-drawer-component') || target.id === 'CartDrawer')) {
      refreshPreview();
    }
  });

  // Fallback: Cart-Add Event
  document.addEventListener('cart:add', refreshPreview);
  document.addEventListener('cart-add', refreshPreview);

  // MutationObserver auf body starten
  observer.observe(document.body, { childList: true, subtree: true });

  // Initial beim Laden (falls Drawer schon im DOM)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshPreview);
  } else {
    refreshPreview();
  }
})();
